export const APPLE_PAY = 'Apple Pay';
export const CREDIT_CARD = 'Credit Card';
export const GOOGLE_PAY = 'Google Pay';
export const OTHER_PAYMENT = 'Other';
